var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"tournament-card-content pl-4 pt-0 pr-4 pb-4",attrs:{"fluid":""}},[_c('TournamentInfoContainer',{staticClass:"pa-0",attrs:{"is-grid":true,"tournament":_vm.tournament}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }